import React from "react";
import _ from "lodash";
import { Helmet } from "react-helmet";

class HelmetComponent extends React.Component {
  render() {
    var defaultTitle = "Gamtred | Admin Panel";
    const data = JSON.parse(localStorage.getItem("organizationalData"));

    return (
      <Helmet>
        <meta charSet="utf-8" />
        <title>{defaultTitle}</title>
        <link
          rel="icon"
          href={!_.isEmpty(data) && data.mediaServerURL + data.logo.large}
        />
        <meta
          name="description"
          content="We offer a tailor-made game-based training solution for companies to increase effectivity in workforce training"
        />
      </Helmet>
    );
  }
}

export default HelmetComponent;
